import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./facebookdelation.css";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Logo from "../img/logo.png";
import { useNavigate, useLocation } from "react-router-dom";

function DataDeletion() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleLogout = () => {
    logout();
  };

  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>Data Deletion Request - Revexia</title>
        <meta
          name="description"
          content="Revexia Data Deletion Request - Learn how to request the deletion of your Revexia account and all associated Facebook data."
        />
      </Helmet>

      <div className="homepage">
        {/* Navigation */}
        <nav className="navbar-custom">
          <div className="navbar-container">
            <div className="navbar-brand-custom">
              <Link to="/">
                <img src={Logo} alt="Revexia Logo" className="navbar-logo-img" />
              </Link>
            </div>

            <div className="navbar-center-pill">
              <ul className="nav-menu-pills">
                <li className="nav-item-pill">
                  <Link to="/" className="nav-link-pill">Home</Link>
                </li>
                <li className="nav-item-pill">
                  <a href="/#features" className="nav-link-pill" onClick={handleClick}>Feature</a>
                </li>
                <li className="nav-item-pill nav-item-dropdown">
                  <button className="nav-link-pill nav-dropdown-toggle">
                    Resources
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" className="dropdown-arrow">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                  <div className="nav-dropdown-menu">
                    <Link to="/how" className="nav-dropdown-item">How it works</Link>
                    <Link to="/support" className="nav-dropdown-item">Support overview</Link>
                    <Link to="/trust" className="nav-dropdown-item">Trust Center</Link>
                    <Link to="/privacy-policy" className="nav-dropdown-item">Privacy Policy</Link>
                    <Link to="/terms" className="nav-dropdown-item">Terms of Service</Link>
                     <Link to="/facebook-terms" className="nav-dropdown-item">
                                          Facebook Terms
                                        </Link>
                  </div>
                </li>
                <li className="nav-item-pill">
                  <Link to="/blog" className="nav-link-pill">Blog</Link>
                </li>
              </ul>
            </div>

            <div className="navbar-auth-section">
              {user ? (
                <>
                  <Link to="/dashboard" className="btn-nav-outline">Dashboard</Link>
                  <button onClick={handleLogout} className="btn-nav-gradient">Logout</button>
                </>
              ) : (
                <>
                  <Link to="/join-waitlist" className="btn-nav-gradient">Get Started</Link>
                  <Link to="/auth" className="btn-nav-gradientlogin">Login</Link>
                </>
              )}
            </div>

            <button
              className="navbar-mobile-toggle"
              type="button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span className="navbar-toggler-icon-custom"></span>
            </button>
          </div>

          {mobileMenuOpen && (
            <div className="navbar-mobile-menu">
              <ul className="mobile-nav-list">
                <li><Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link></li>
                <li>
                  <a href="/#features" onClick={(e) => { setMobileMenuOpen(false); handleClick(e); }}>Feature</a>
                </li>
                <li><Link to="/how" onClick={() => setMobileMenuOpen(false)}>How it works</Link></li>
                <li><Link to="/support" onClick={() => setMobileMenuOpen(false)}>Support overview</Link></li>
                <li><Link to="/trust" onClick={() => setMobileMenuOpen(false)}>Trust Center</Link></li>
                <li><Link to="/blog" onClick={() => setMobileMenuOpen(false)}>Blog</Link></li>
              </ul>
              <div className="mobile-auth-buttons">
                {user ? (
                  <>
                    <Link to="/dashboard" className="btn-nav-outline" onClick={() => setMobileMenuOpen(false)}>Dashboard</Link>
                    <button onClick={() => { handleLogout(); setMobileMenuOpen(false); }} className="btn-nav-gradient">Logout</button>
                  </>
                ) : (
                  <Link to="/auth" className="btn-nav-gradient" onClick={() => setMobileMenuOpen(false)}>Login</Link>
                )}
              </div>
            </div>
          )}
        </nav>

        {/* Data Deletion Content */}
        <div className="deletion-content-wrapper">
          {/* Header Section */}
          <div className="deletion-header-section">
            <div className="deletion-container">
              {/* Icon */}
              <div className="deletion-icon-wrapper">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="48" height="48" rx="14" fill="rgba(91,127,255,0.12)" />
                  <path d="M16 18H32M30 18L29.1245 30.1327C29.0544 31.1264 28.2202 31.9 27.2238 31.9H20.7762C19.7798 31.9 18.9456 31.1264 18.8755 30.1327L18 18" stroke="#5B7FFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M21 18V16.5C21 15.9477 21.4477 15.5 22 15.5H26C26.5523 15.5 27 15.9477 27 16.5V18" stroke="#5B7FFF" strokeWidth="1.8" strokeLinecap="round" />
                  <path d="M24 22V28" stroke="#5B7FFF" strokeWidth="1.8" strokeLinecap="round" />
                  <path d="M21.5 22.5L22 28" stroke="#5B7FFF" strokeWidth="1.8" strokeLinecap="round" />
                  <path d="M26.5 22.5L26 28" stroke="#5B7FFF" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
              </div>

              <h1 className="deletion-main-title">Data Deletion Request</h1>
              <p className="deletion-last-updated">Last updated: 28.01.2026</p>
              <p className="deletion-intro-text">
                You have the right to request the deletion of your Revexia account and all associated data,
                including any Facebook data connected through our platform.
              </p>
              <p className="deletion-intro-text deletion-highlight">
                We are committed to honoring your data rights promptly and transparently.
              </p>
            </div>
          </div>

          {/* Content Section */}
          <div className="deletion-content-section">
            <div className="deletion-container">

              {/* Method 1 */}
              <div className="deletion-section">
                <div className="deletion-method-badge">Method 1</div>
                <h2 className="deletion-section-title">Delete via Dashboard</h2>
                <p className="deletion-paragraph">
                  The quickest way to request deletion is directly through your Revexia account dashboard.
                </p>
                <div className="deletion-steps">
                  <div className="deletion-step">
                    <div className="deletion-step-number">01</div>
                    <div className="deletion-step-content">
                      <p className="deletion-step-text">Log into your <strong>Revexia dashboard</strong></p>
                    </div>
                  </div>
                  <div className="deletion-step-connector"></div>
                  <div className="deletion-step">
                    <div className="deletion-step-number">02</div>
                    <div className="deletion-step-content">
                      <p className="deletion-step-text">Navigate to <strong>Settings</strong></p>
                    </div>
                  </div>
                  <div className="deletion-step-connector"></div>
                  <div className="deletion-step">
                    <div className="deletion-step-number">03</div>
                    <div className="deletion-step-content">
                      <p className="deletion-step-text">Click <strong>'Delete Account'</strong> to submit your request</p>
                    </div>
                  </div>
                </div>

                {user && (
                  <div className="deletion-cta-wrapper">
                    <Link to="/dashboard/settings" className="deletion-cta-button">
                      Go to Settings
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </Link>
                  </div>
                )}
              </div>

              {/* Divider with OR */}
              <div className="deletion-or-divider">
                <span className="deletion-or-line"></span>
                <span className="deletion-or-text">OR</span>
                <span className="deletion-or-line"></span>
              </div>

              {/* Method 2 */}
              <div className="deletion-section">
                <div className="deletion-method-badge">Method 2</div>
                <h2 className="deletion-section-title">Email Support Team</h2>
                <p className="deletion-paragraph">
                  Alternatively, you can contact our support team directly via email to request account and data deletion.
                </p>

                <div className="deletion-email-card">
                  <div className="deletion-email-card-inner">
                    <div className="deletion-email-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="#5B7FFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M22 6L12 13L2 6" stroke="#5B7FFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div className="deletion-email-details">
                      <p className="deletion-email-label">Send an email to</p>
                      <a href="mailto:support@revexia.ai?subject=Data Deletion Request" className="deletion-email-address">
                        support@revexia.ai
                      </a>
                      <p className="deletion-email-subject-label">With the subject line:</p>
                      <div className="deletion-subject-pill">
                        <span>"Data Deletion Request"</span>
                        <button
                          className="deletion-copy-btn"
                          onClick={() => navigator.clipboard.writeText("Data Deletion Request")}
                          title="Copy subject"
                        >
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <rect x="4" y="4" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
                            <path d="M2 10V2.5A.5.5 0 012.5 2H10" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <a
                    href="mailto:support@revexia.ai?subject=Data Deletion Request"
                    className="deletion-email-btn"
                  >
                    Open Email Client
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M2.5 7H11.5M11.5 7L8 3.5M11.5 7L8 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </a>
                </div>
              </div>

              {/* What happens next */}
              <div className="deletion-section">
                <h2 className="deletion-section-title">What Happens Next</h2>
                <p className="deletion-paragraph">
                  Once we receive your deletion request, here is what you can expect:
                </p>
                <ul className="deletion-list">
                  <li>We will verify your identity to protect your account security</li>
                  <li>Your account and all associated data will be permanently deleted within <strong>30 days</strong></li>
                  <li>All connected Facebook data processed through Revexia will be removed</li>
                  <li>You will receive a confirmation email once the deletion is complete</li>
                  <li>Some data may be retained for legal or compliance purposes as outlined in our <Link to="/privacy-policy" className="deletion-inline-link">Privacy Policy</Link></li>
                </ul>
                <p className="deletion-paragraph deletion-highlight">
                  Please note: Account deletion is permanent and cannot be undone. Make sure to download any data you wish to keep before submitting your request.
                </p>
              </div>

              {/* Contact Box */}
              <div className="deletion-section">
                <h2 className="deletion-section-title">Need Help?</h2>
                <p className="deletion-paragraph">
                  If you have any questions about the data deletion process, our team is here to help.
                </p>
                <div className="deletion-contact-box">
                  <p className="deletion-contact-brand">Revexia</p>
                  <a href="mailto:support@revexia.ai" className="deletion-contact-link">
                    📧 support@revexia.ai
                  </a>
                  <a href="https://www.revexia.ai" target="_blank" rel="noopener noreferrer" className="deletion-contact-link">
                    🌍 https://www.revexia.ai
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer-v2" id="contact">
          <div className="container-footer-v2">
            <div className="footer-main-content">
              <div className="footer-brand-section-v2">
                <div className="footer-logo-wrapper">
                  <img src={Logo} alt="Revexia" className="footer-logo-image" />
                </div>
                <p className="footer-brand-description-v2">
                  A platform to turn social media DM engagement into automated revenue with AI-driven personalization.
                </p>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Informations</h4>
                <ul className="footer-column-links-v2">
                  <li><a href="/">Home</a></li>
                </ul>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Social</h4>
                <ul className="footer-column-links-v2">
                  <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                  <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                  <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                  <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                  <li><a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">TikTok</a></li>
                </ul>
              </div>

              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Help</h4>
                <ul className="footer-column-links-v2">
                  <li><Link to="/contact">Contact</Link></li>
                  <li><Link to="/terms">Terms & conditions</Link></li>
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                   <li>
                                      <Link to="/facebook-terms">Facebook Terms</Link>
                                    </li>
                </ul>
              </div>
            </div>

            <hr className="footer-divider-line-v2" />

            <div className="footer-bottom-v2">
              <p className="footer-copyright-v2">
                © 2026 Revexia. All rights reserved. Developed by{" "}
                <a href="https://softwarebari.com" target="_blank" rel="noopener noreferrer" className="developer-link">
                  Softwarebari
                </a>.
              </p>
              <div className="footer-legal-links-v2">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <span className="separator-v2">|</span>
                <Link to="/terms">Terms &amp; Conditions</Link>
                <span className="separator-v2">|</span>
                <a href="/cookies">Cookies Policy</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default DataDeletion;